import Cookies from 'js-cookie';

const ADDRESS_KEY = 'address';
const ADDRESS_DEFAULT = 'Brooklyn, New York';

const LOCATION_KEY = 'location';
const LOCATION_DEFAULT = {
  lat: 40.650002,
  lng: -73.949997,
};

const EXPIRATION_DAYS = 7;

export default {
  initialize() {
    return new Promise((resolve) => {
      // Get current location
      navigator.geolocation.getCurrentPosition((position) => {
        const location = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        // Get address formatted
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location }, (results, status) => {
          if (status === 'OK') {
            const city = this.findAddress(results[0], 'locality');
            const state = this.findAddress(results[0], 'administrative_area_level_1');

            resolve({
              address: `${city}, ${state}`,
              location,
            });
          }
        });
      });
    });
  },

  /**
   * Get address of specific type from cookie.
   *
   * @returns {string}
   */
  findAddress(place, type) {
    return (place.address_components.find(x => x.types.includes(type)) || {}).long_name;
  },

  /**
   * Get address from cookie.
   *
   * @returns {string}
   */
  getAddress() {
    return Cookies.get(ADDRESS_KEY) || ADDRESS_DEFAULT;
  },

  /**
   * Set address in cookies.
   *
   * @param {string} address
   */
  setAddress(address) {
    Cookies.set(ADDRESS_KEY, address, EXPIRATION_DAYS);
  },

  /**
   * Get location from cookie.
   *
   * @returns {object}
   */
  getLocation() {
    return Cookies.getJSON(LOCATION_KEY) || LOCATION_DEFAULT;
  },

  /**
   * Set location in cookies.
   *
   * @param {object} location
   */
  setLocation(location) {
    Cookies.set(LOCATION_KEY, location, EXPIRATION_DAYS);
  },

  /**
   * Check if has a current location stored.
   *
   * @returns {boolean}
   */
  isCurrentLocation() {
    return !!Cookies.get(LOCATION_KEY);
  },
};
